import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_API = `${BACKEND_URL}/api/admin`;

const STORAGE_KEY = "sozos.admin.auth";

export function saveAdminAuth(username, password) {
  const token = btoa(`${username}:${password}`);
  sessionStorage.setItem(STORAGE_KEY, token);
  return token;
}

export function getAdminAuth() {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearAdminAuth() {
  sessionStorage.removeItem(STORAGE_KEY);
}

function withAuth(headers = {}) {
  const token = getAdminAuth();
  return token ? { ...headers, Authorization: `Basic ${token}` } : headers;
}

export async function adminLogin(username, password) {
  const token = btoa(`${username}:${password}`);
  const res = await axios.get(`${ADMIN_API}/me`, {
    headers: { Authorization: `Basic ${token}` },
  });
  saveAdminAuth(username, password);
  return res.data;
}

export async function fetchStats() {
  const res = await axios.get(`${ADMIN_API}/stats`, { headers: withAuth() });
  return res.data;
}

export async function fetchLeads({ q = "", limit = 200 } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  const res = await axios.get(`${ADMIN_API}/leads?${params.toString()}`, { headers: withAuth() });
  return res.data;
}

export async function fetchContactMessages(limit = 200) {
  const res = await axios.get(`${ADMIN_API}/contact-messages?limit=${limit}`, { headers: withAuth() });
  return res.data;
}

export async function deleteLead(id) {
  await axios.delete(`${ADMIN_API}/leads/${id}`, { headers: withAuth() });
}
